const STORAGE_KEY = 'nbna.meeting.match.v1';

function todayKey(date = new Date()) {
  // Local-date key (YYYY-MM-DD) is good enough for UI gating.
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function persistTodayMatch(payload) {
  if (!payload || typeof payload !== 'object') return;

  const matchMember = payload?.match?.member;
  if (!matchMember?.id) return;

  const record = {
    dateKey: todayKey(),
    member: {
      id: String(matchMember.id),
      displayName: String(matchMember.displayName ?? ''),
      googleBusinessProfileUrl: String(matchMember.googleBusinessProfileUrl ?? ''),
    },
    assignedAt: payload?.match?.assignedAt ?? null,
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // Ignore storage failures (private browsing, etc.).
  }
}

export function readTodayMatch() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.dateKey !== todayKey()) return null;
    if (!parsed?.member?.id) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearTodayMatch() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
